import axios from 'axios'
import { THIRD_ACCESS_TOKEN } from 'utils/constants'
import { LocalStorage, E_PRODUCT2_RES } from 'utils/config'
import request from 'request/index'
export default {
  sGetEdmodoUser (token) {
    const access_token = token || LocalStorage.get(THIRD_ACCESS_TOKEN)
    return axios({
      method: 'get',
      url: `${window.location.protocol}//api.edmodo.com/users/me`,
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
  },
  // 3.3.2.1 批量获取评论用户信息 [GET] /visitor/app/comment/users?user_ids=10000,123456
  sGetCommentUser (user_ids) {
    return request({
      method: 'GET',
      res: E_PRODUCT2_RES,
      api: '/visitor/app/comment/users',
      query: {
        user_ids
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/edmodo/user.js